import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { ENUM_TABS } from 'constants/enum';
import UsersDetailHeader from 'pages/Users/Detail/_components/Header';
import Sidebar from 'pages/Users/Detail/_components/Sidebar';
import AnswerResult from 'pages/Users/Detail/AnswerResult/AnswerResult';
import Home from 'pages/Users/Detail/Home/Home';
import ReportList from 'pages/Users/Detail/ReportList/ReportList';
import ReportRegistration from 'pages/Users/Detail/ReportRegistration/ReportRegistration';
import VideoResult from 'pages/Users/Detail/VideoResult/VideoResult';
import { clearChildrenDetail, setCreateReportData } from 'store/actions/children';
import { calculatorHeightContain } from 'utils/helper';

import Breadcrumb from './_components/Breadcrumb';

const DEFAULT_TAB = ENUM_TABS.HOME;

const UsersDetailLayout = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [heightUsersDetail, setHeightUsersDetail] = useState(0);
  const [tabActive, setTabActive] = useState(DEFAULT_TAB);
  const [breadcrumbs, setBreadcrumbs] = useState([
    {
      title: t('USER_LIST'),
      event: () => setTabActive(ENUM_TABS.HOME),
    },
    {
      title: t('HOME'),
    },
  ]);

  useEffect(() => {
    const main = document.getElementById('main');
    main.style.paddingBottom = '0';
    main.style.paddingTop = '0';
    const height = calculatorHeightContain([{ id: 'users-detail-header' }], [{ id: 'main' }], [], 56);
    setHeightUsersDetail(height);

    return () => {
      main.style.paddingBottom = '24px';
      main.style.paddingTop = '24px';

      dispatch(clearChildrenDetail());
    };
  }, []);

  useEffect(() => {
    if (location.state && location.state.reportId) {
      setTabActive(ENUM_TABS.REPORT_CREATE);
      dispatch(setCreateReportData({ reportId: location.state.reportId, evaluationId: location.state.evaluationId }));
    }

    return () => {
      window.history.replaceState({}, document.title);
    };
  }, [location.state]);

  return (
    <>
      <Breadcrumb breadcrumbs={breadcrumbs} />
      <UsersDetailHeader />
      <div className="py-2 px-8 flex space-x-4 overflow-hidden" style={{ height: heightUsersDetail }}>
        <Sidebar tabActive={tabActive} setTabActive={setTabActive} setBreadcrumbs={setBreadcrumbs} />
        <div className="w-full">
          {tabActive === ENUM_TABS.HOME && <Home />}
          {tabActive === ENUM_TABS.ANSWER_RESULT_LIST && <AnswerResult />}
          {tabActive === ENUM_TABS.ANSWER_RESULT_VIDEO && <VideoResult />}
          {tabActive === ENUM_TABS.REPORT_LIST && <ReportList />}
          {tabActive === ENUM_TABS.REPORT_CREATE && <ReportRegistration />}
        </div>
      </div>
    </>
  );
};

export default UsersDetailLayout;
